export default __webpack_public_path__ + "static/N0006-77c529b15e18ee89af6cb2ebb97a87a3.png";